import { Grid } from "@mui/material";
import ThemeContext from "components/app/Context";
import { setSavedFilterByType, updateCorpSavedFilters } from "components/common/Filters/Filters.slice";
import { filterPage, filterPayloadForSelectAllFeature } from "components/common/Filters/FiltersHelper";
import GlobalFilterDescription from "components/common/Filters/GlobalFilterDescription";
import GlobalFilters from "components/common/Filters/GlobalFilters";
import { setPageFilter } from "components/common/Filters/GlobalFilters.slice";
import Typography from "components/common/Typography";
import UrlTabs from "components/common/UrlTabs";
import { useTranslate } from "hooks/useTranslate";
import React, { useContext, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { resetAllSorting } from "redux/sorting.slice";
import { tokens } from "styles/Tokens";
import { responseTypes } from "utils/Types";
import { setCorpSearchText } from "../CorpUser.Slice";
import "./CorpView.scss";
import ModalHandler from "./ModalHandler";
import { tabDetails } from "./TabsConfig";

interface Props {
  selectedListFiltersList?: any;
  selectedList?: any;
  view?: string;
  selectedListType?: any;
}

const CorpView = (props: Props) => {
  const dispatch = useAppDispatch();
  const translate = useTranslate();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");

  const { view = "myList", selectedListType, selectedList } = props;
  const page =
    selectedListType === "consultant"
      ? filterPage.consultantListDisplay
      : view === "myList"
      ? filterPage.listDisplay
      : filterPage.dashboardDisplay;

  const selectedTabs = useAppSelector((state) => state.CorpDashboard.selectedTabs);
  const globalFiltersforPage = useAppSelector((state) => state.globalFilters[page]);
  const { isMobileScreen } = useContext(ThemeContext);

  const onTabChangeCallback = () => {
    dispatch(resetAllSorting({}));
    dispatch(setCorpSearchText({ view: view, value: "" }));
  };

  const updateFilters = async () => {
    let parentObject: any = {
      id: selectedList?.id,
      filters: filterPayloadForSelectAllFeature(globalFiltersforPage?.modifiedFilter)
    };
    if (selectedListType === "dynamic")
      parentObject = {
        ...parentObject,
        name: selectedList?.name,
        description: selectedList?.description,
        isFlagged: "N"
      };

    const props = {
      [selectedListType]: [parentObject]
    };
    const response = await dispatch(updateCorpSavedFilters(props));
    if (response.payload.status < responseTypes.success_threshold) {
      const payload = {
        data: response.payload[selectedListType],
        type: selectedListType
      };
      dispatch(setSavedFilterByType(payload)); //update default filters in filters slice

      dispatch(
        setPageFilter({
          pageName: selectedListType === "dynamic" ? filterPage.listDisplay : filterPage.dashboardDisplay,
          defaultFilter: globalFiltersforPage?.modifiedFilter?.filter((item: any) => item?.options?.length),
          modifiedFilter: []
        })
      ); //update default & modified in global filters
    }
  };

  const tabs = useMemo(() => tabDetails(view, selectedListType, selectedList), [selectedList]);

  return (
    <>
      <Grid
        className="corp-view-component"
        display={"flex"}
        flexDirection={isMobileScreen ? "column" : "row"}
        justifyContent={"space-between"}
        alignItems={"left"}
      >
        <div>
          <Typography variant={"h4"} showBold className="corp-view-heading" component={"div"}>
            {view === "dashboard" ? "Filtered View" : selectedList?.name}
          </Typography>
          {selectedListType === "bookmarked" && (
            <Typography variant={"label"} component={"div"} color={tokens.Text.General.PrimaryBody}>
              {translate("common.defaultSystemList")}
            </Typography>
          )}
        </div>
        <div className="corp-view-filters">
          <GlobalFilters
            isGlobalCheckBoxApplicable={view === "dashboard"}
            isDefaultButtonsApplicable={selectedListType === "default" || selectedListType === "dynamic"}
            page={page}
            updateSavedFilter={updateFilters}
          />
        </div>
      </Grid>

      <GlobalFilterDescription isGlobalCheckBoxApplicable={view === "dashboard"} page={page} />

      {(selectedListType === "static" || selectedListType === "consultant") && selectedList?.description && (
        <div className="corp-view-list-description">
          <Typography variant="label">{selectedList?.description}</Typography>
        </div>
      )}

      <UrlTabs
        tabs={tabs}
        tabParam="tab"
        defaultTab={selectedTabs[view]}
        retainFilters
        onTabChangeCallback={onTabChangeCallback}
      />
      <ModalHandler />
    </>
  );
};
export default React.memo(CorpView);
